"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecalculateModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dialog_1 = require("primereact/dialog");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const FiltersComponent_1 = require("../../../components/filter/FiltersComponent");
const ApiClubRepo_1 = require("../../../modules/club/infra/ApiClubRepo");
const getAll_1 = require("../../../modules/club/app/getAll");
const FilterContext_1 = require("../../../context/filters/FilterContext");
const GenericButton_1 = require("../../../components/web-view/button/GenericButton");
const useIsMobile_1 = require("../../../hooks/mobile/useIsMobile");
const useClubInvoice_1 = require("../context/useClubInvoice");
const toastContext_1 = require("../../../context/toast/toastContext");
const RecalculateModal = ({ visible, onConfirm, onCancel, handleMonthYearChange, selectedMonth, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { filters, setFilters } = (0, FilterContext_1.useFilters)();
    const [clubs, setClubs] = (0, react_1.useState)([]);
    const [clubId, setClubId] = (0, react_1.useState)('');
    const [selectedClub, setSelectedClub] = (0, react_1.useState)(filters.clubId || '');
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { generate } = (0, useClubInvoice_1.useClubInvoice)();
    const { toastRef } = (0, toastContext_1.useToastContext)();
    const fetchClubs = (0, react_1.useCallback)(async () => {
        const clubRepo = (0, ApiClubRepo_1.createApiClubRepo)();
        try {
            const clubList = await (0, getAll_1.getAll)(clubRepo);
            if (clubList) {
                const formattedClubs = clubList.map((club) => ({
                    label: club.clubName,
                    value: club.clubName,
                    id: club.clubId,
                }));
                setClubs(formattedClubs);
            }
            else {
                console.error('Product list is empty or undefined:', clubList);
            }
        }
        catch (error) {
            console.error('Error fetching clubs:', error);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        const fetchInitialClubData = async () => {
            if (clubs.length === 0) {
                await fetchClubs();
            }
        };
        fetchInitialClubData();
    }, []);
    (0, react_1.useEffect)(() => {
        if (selectedClub && clubs.length > 0) {
            const club = clubs.find((club) => club.value === selectedClub)?.id;
            setClubId(club || '');
        }
    }, [selectedClub, clubs]);
    const onClubChange = (0, react_1.useCallback)((clubId) => {
        setSelectedClub(clubId);
        setFilters({
            globalFilterValue: filters.globalFilterValue || '',
            startDate: filters.startDate || null,
            endDate: filters.endDate || null,
            clubId: clubId || null,
        });
    }, []);
    const generateInvoice = () => {
        if (selectedMonth?.month && selectedMonth?.year) {
            generate(clubId, selectedMonth.year, selectedMonth.month)
                .then((res) => {
                if (!res) {
                    console.error('Failed to generate invoice: response is null or undefined');
                    toastRef.current?.show({
                        severity: 'info',
                        summary: t('Information'),
                        detail: t('monthWithoutInvoices'),
                        life: 3000,
                    });
                    return;
                }
                onConfirm();
                toastRef.current?.show({
                    severity: 'success',
                    summary: t('Success'),
                    detail: t('successGenerateInvoices'),
                    life: 3000,
                });
            })
                .catch((error) => {
                console.error('Error generating invoice:', error);
                toastRef.current?.show({
                    severity: 'error',
                    summary: t('Error'),
                    detail: t('errorGenerateInvoices'),
                    life: 3000,
                });
            });
        }
        else {
            console.error('Selected month or year is not defined');
        }
    };
    return ((0, jsx_runtime_1.jsx)(dialog_1.Dialog, { visible: visible, onHide: onCancel, header: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: t('generateInvoices') }), ' ', !isMobile && ((0, jsx_runtime_1.jsxs)("div", { className: `mt-2 w-fit px-3 bg-orange-100 text-orange-700 text-xs py-2 rounded-full`, children: ["* ", t('warningGenerateInvoiceText')] }))] }), className: `${isMobile ? 'w-[98%] p-0' : 'w-[50vw]'} montserratMedium`, draggable: false, dismissableMask: true, closable: true, showHeader: true, contentClassName: 'w-full h-full p-0', children: (0, jsx_runtime_1.jsx)("div", { className: "w-full p-d-flex p-ai-center p-jc-center", style: { height: '100%' }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                    width: '100%',
                    height: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }, children: [(0, jsx_runtime_1.jsx)("div", { className: `${isMobile ? 'w-full' : 'w-3/4'} flex justify-center items-center mt-4 mb-2 `, children: (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { handleMonthYearChange: handleMonthYearChange, onlyMonth: true, onClubChange: onClubChange, clubs: clubs, selectedClub: selectedClub, resetPageToFirst: function () {
                                throw new Error('Function not implemented.');
                            } }) }), (0, jsx_runtime_1.jsxs)("div", { className: "w-full flex justify-center items-center gap-2 mt-10 mb-4", children: [(0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { label: t('cancel'), onClick: onCancel }), (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { label: t('generate'), onClick: generateInvoice })] }), isMobile && ((0, jsx_runtime_1.jsxs)("div", { className: `mt-2 mb-4 ml-2 w-fit px-3 bg-orange-100 text-orange-700 text-xs py-2 rounded-full`, children: ["* ", t('warningGenerateInvoiceText')] }))] }) }) }));
};
exports.RecalculateModal = RecalculateModal;
